import { Button, Flex, Form, Input, Modal, message } from 'antd';
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';

import { useAddCollection } from '@/api/monitor_collections';

type TProps = {
	isOpen: boolean;
	setOpen: any;
	type: 'videos' | 'creators';
};

export default function AddCollectionModal({
	isOpen = false,
	setOpen,
	type,
}: TProps) {
	const [form] = useForm();

	const { mutate: addCollection, isLoading: isAddCollectionLoading } =
		useAddCollection(type);

	const handleOk = async () => {
		try {
			await form.validateFields();

			const { title, description } = form.getFieldsValue();

			addCollection(
				{
					type,
					title: title?.trim(),
					description: description ? description?.trim() : '',
				},
				{
					onSuccess: () => {
						message.success('Added');
						setOpen(false);
						form.resetFields();
					},
					onError: (error) => {
						const err = error as any;
						message.error(
							`An error occured: ${
								err?.response?.data?.message || err?.message
							}.`,
						);
						console.error('error', error);
					},
				},
			);
		} catch (error) {
			console.error('Error adding collection:', error);
			message.error('Please fill all required fields.');
		}
	};

	const handleCancel = () => {
		setOpen(false);
	};

	return (
		<Modal
			title={'Add collection'}
			centered
			open={isOpen}
			onOk={handleOk}
			onCancel={handleCancel}
			closable
			maskClosable={false}
			footer={[
				<Button
					key="back"
					size="small"
					onClick={handleCancel}
					disabled={isAddCollectionLoading}
				>
					Cancel
				</Button>,
				<Button
					key="submit"
					size="small"
					type="primary"
					loading={isAddCollectionLoading}
					onClick={handleOk}
					disabled={isAddCollectionLoading}
				>
					Add
				</Button>,
			]}
		>
			<Form
				form={form}
				layout="vertical"
				initialValues={{
					name: '',
					description: '',
				}}
				style={{ marginBottom: '1rem' }}
			>
				<Flex vertical gap={16}>
					<Form.Item
						name="title"
						label="Title"
						// layout="vertical"
						rules={[
							{
								required: true,
								message: 'Collection title is required.',
							},
							{
								whitespace: true,
								message: 'Collection title cannot be empty.',
							},
						]}
						style={{ margin: 0 }}
					>
						<Input placeholder={'Collection name'} style={{ resize: 'none' }} />
					</Form.Item>

					<Form.Item
						label="Description"
						name="description"
						style={{ marginBottom: '1rem' }}
					>
						<TextArea
							placeholder={'Collection description'}
							style={{ resize: 'none' }}
							rows={3}
							maxLength={255}
							count={{
								show: true,
								max: 255,
							}}
						/>
					</Form.Item>
				</Flex>
			</Form>
		</Modal>
	);
}
